import { openTaskCreate } from '@plugin/task/store/useTaskCreateStore';
import { openProductCreate } from '@plugin/products/store/useProductCreateStore'
export const storeRegistry = {
  'createTask': {openTaskCreate},
  'createProduct': {openProductCreate},
};